import { apiFetch, readJson } from './client';

export interface ClientUserActivityOmitEmail {
  id: number;
  email: string;
  description?: string | null;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  modifiedBy: string;
  modifiedAt: string;
}

export interface ClientUserActivityOmitEmailUpsert {
  email: string;
  description?: string | null;
  isActive: boolean;
}

const base = '/api/admin/client-user-activity-omit-emails';

export async function listClientUserActivityOmitEmails(): Promise<ClientUserActivityOmitEmail[]> {
  const res = await apiFetch(base);
  if (!res.ok) throw new Error(`List failed (${res.status})`);
  return readJson<ClientUserActivityOmitEmail[]>(res);
}

export async function createClientUserActivityOmitEmail(
  body: ClientUserActivityOmitEmailUpsert
): Promise<ClientUserActivityOmitEmail> {
  const res = await apiFetch(base, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { errorText?: string }).errorText ?? `Create failed (${res.status})`);
  }
  return readJson<ClientUserActivityOmitEmail>(res);
}

export async function updateClientUserActivityOmitEmail(
  id: number,
  body: ClientUserActivityOmitEmailUpsert
): Promise<ClientUserActivityOmitEmail> {
  const res = await apiFetch(`${base}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { errorText?: string }).errorText ?? `Update failed (${res.status})`);
  }
  return readJson<ClientUserActivityOmitEmail>(res);
}

export async function deleteClientUserActivityOmitEmail(id: number): Promise<void> {
  const res = await apiFetch(`${base}/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`Delete failed (${res.status})`);
}
